<mat-card
  [class.border-proffeo-feedback-success-border]="isActiveProject()"
  [class.border-2]="isActiveProject()"
  class="my-3 w-full rounded-md bg-proffeo-surface border border-proffeo-border"
>
  <mat-card-content
    (click)="onProjectSelect()"
    class="p-4 cursor-pointer"
  >
    <div class="grid grid-cols-1 gap-4 md:grid-cols-[auto_1fr_auto_auto] md:items-center">
      <!-- Avatar -->
      <div class="flex justify-center md:justify-start">
        <proffeo-project-avatar
          [url]="$safeNavigationMigration(project()?.avatarUrl)"
          [projectName]="$safeNavigationMigration(project()?.name)"
          size="medium"
        ></proffeo-project-avatar>
      </div>

      <!-- Project info -->
      <div class="min-w-0">
        <div class="flex items-start justify-between gap-2">
          <h3 class="text-lg font-semibold text-proffeo-text truncate">
            {{ project()?.name }}
          </h3>

          <!-- Mobile menu -->
          <button
            (click)="$event.stopPropagation()"
            [matMenuTriggerFor]="menu"
            class="md:hidden"
          >
            <mat-icon
              fontIcon="more_vert"
              class="icon-muted"
            />
          </button>
        </div>

        <p class="mt-1 text-sm text-proffeo-muted truncate">
          {{ project()?.description }}
        </p>
      </div>

      <!-- Statistics -->
      <div class="grid grid-cols-2 gap-4 sm:flex sm:gap-3 sm:justify-end">
        <proffeo-hours-statistics
          [usedHours]="$safeNavigationMigration(project()?.statistic?.hours)!"
          [estimationHours]="$safeNavigationMigration(project()?.estimation?.hours)!"
          class="w-full md:w-24"
        ></proffeo-hours-statistics>

        <proffeo-days-counter-statistics
          [startDate]="$safeNavigationMigration(project()?.startDate)!"
          [endDate]="$safeNavigationMigration(project()?.endDate)!"
          class="w-full md:w-24"
        ></proffeo-days-counter-statistics>
      </div>

      <!-- Desktop menu -->
      <div class="hidden md:flex justify-end">
        <button
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="menu"
        >
          <mat-icon
            fontIcon="more_vert"
            class="icon-muted"
          />
        </button>
      </div>
    </div>

    <mat-menu #menu="matMenu">
      <div class="flex h-full w-full flex-col">
        @if (!isSelectedProject() && !isArchivedProject() && !isDraftProject()) {
          <div
            (click)="setActiveProject.emit(project())"
            class="flex cursor-pointer w-full gap-1 items-center px-4 py-2 group hover:bg-proffeo-accent transition-default"
          >
            <mat-icon
              fontIcon="check_circle_outline"
              class="group-hover:icon-white"
            />
            <p class="group-hover:icon-white">
              {{ 'company-projects.list-actions.set-active' | translate }}
            </p>
          </div>
        }

        @if (isActiveProject()) {
          <div
            (click)="exportTaskImportTemplate.emit(project())"
            class="flex cursor-pointer w-full gap-1 items-center px-4 py-2 group hover:bg-proffeo-accent transition-default"
          >
            <mat-icon
              fontIcon="file_download"
              class="group-hover:icon-white"
            />
            <p class="group-hover:icon-white">
              {{ 'company-projects.list-actions.export-task-import-template' | translate }}
            </p>
          </div>
        }

        @if (!isArchivedProject()) {
          <div
            (click)="editProject.emit(project())"
            class="flex cursor-pointer w-full gap-1 items-center px-4 py-2 group hover:bg-proffeo-accent transition-default"
          >
            <mat-icon
              fontIcon="edit"
              class="group-hover:icon-white"
            />
            <p class="group-hover:icon-white">
              {{ 'company-projects.list-actions.edit' | translate }}
            </p>
          </div>
        }

        @if (!isArchivedProject() && !isDraftProject()) {
          <div
            (click)="archiveProject.emit(project())"
            class="flex cursor-pointer w-full gap-1 items-center px-4 py-2 group hover:bg-proffeo-accent transition-default"
          >
            <mat-icon
              fontIcon="inventory"
              class="group-hover:icon-white"
            />
            <p class="group-hover:icon-white">
              {{ 'company-projects.list-actions.archive-the-project' | translate }}
            </p>
          </div>
        }

        @if (isArchivedProject()) {
          <div
            (click)="restoreProject.emit(project())"
            class="flex cursor-pointer w-full gap-1 items-center px-4 py-2 group hover:bg-proffeo-accent transition-default"
          >
            <mat-icon
              fontIcon="inventory"
              class="group-hover:icon-white"
            />
            <p class="group-hover:icon-white">
              {{ 'company-projects.list-actions.restore-the-project' | translate }}
            </p>
          </div>
        }

        @if (isArchivedProject() || isDraftProject()) {
          <div
            (click)="deleteProject.emit(project())"
            class="flex cursor-pointer w-full gap-1 items-center px-4 py-2 group hover:bg-proffeo-accent transition-default"
          >
            <mat-icon
              fontIcon="delete"
              class="group-hover:icon-white"
            />
            <p class="group-hover:icon-white">
              {{ 'company-projects.list-actions.delete' | translate }}
            </p>
          </div>
        }
      </div>
    </mat-menu>
  </mat-card-content>
</mat-card>
